import React, { Component } from 'react';
import { connect } from 'react-redux';
import MultipleChoiceQuestion from 'components/questions/multipleChoiceQuestion/MultipleChoiceQuestion';
import SingleChoiceQuestion from 'components/questions/singleChoiceQuestion/SingleChoiceQuestion';
//import DragAndDropQuestion from 'components/notebook/notebookPopout/reflection/multipleChoiceQuestion/DragAndDropQuestion';

import ReflectionData from 'data/notebook.json';

import {
    createMCQ,
    createSCQ,
    //createDND,
} from 'actions';

import colors from 'styles/_exports.module.scss';

import { withTranslation } from 'react-i18next'

class Reflection extends Component {

    constructor(props) {
        super(props);

        this.state = {
            components: []
        }
    }

    componentDidMount(){
        this.doReduxPart(ReflectionData.Notebook.Content.Reflection)
        this.doCompPart(ReflectionData.Notebook.Content.Reflection)
    }

    doReduxPart = (data) => {
        data.components.forEach(comp => {
            this.setupComponentRedux(comp)
        })
    }

    doCompPart = (data) => {
        const compArr = []

        data.components.forEach((comp, index) => {
          const componentData = [];

          if((index + 1) === data.components.length){
            componentData.push(
              <div>

                <h2 style={{margin: '32px 0 8px'}}>{this.props.t("Feedback question")}</h2>
                <div style={{width: '100%', height: '1px', background: colors.navy1, marginTop: '8px'}}></div>
              </div>
            )
          }
          componentData.push(this.buildComponent(comp, index))
          compArr.push(componentData)
        })

        this.setState({
            components: compArr
        })
    }

    setupComponentRedux = (data) => {
        switch (data.component) {
            case "MCQ":
                this.props.createMCQ({
                  id: data.props.id,
                  type: data.props.type,
                  choices: data.props.levels['l'+this.props.level].choices,
                  label: data.props.levels['l'+this.props.level].label,
                  attempts: data.props.levels['l'+this.props.level].attempts,
                  answer: data.props.levels['l'+this.props.level].answer,
                  correct: data.props.levels['l'+this.props.level].correct
                })
                break;

            case "SCQ":
                this.props.createSCQ({
                  id: data.props.id,
                  type: data.props.type,
                  choices: data.props.levels['l'+this.props.level].choices,
                  label: data.props.levels['l'+this.props.level].label,
                  attempts: data.props.levels['l'+this.props.level].attempts,
                  answer: data.props.levels['l'+this.props.level].answer,
                  correct: data.props.levels['l'+this.props.level].correct
                })
                break;
            //
            // case "DND":
            //     this.props.createDND({
            //         id: data.props.id,
            //         type: data.props.type,
            //     })
                // break;

            default:
                break;
        }
    }

    buildComponent = (data, index) => {
        switch (data.component) {
            case "MCQ":
                return (<MultipleChoiceQuestion key={index} type={data.props.type} id={data.props.id} index={index}/>)

            case "SCQ":
                return (<SingleChoiceQuestion key={index} type={data.props.type} id={data.props.id} index={index}/>)

            // case "DND":
            //     return (<DragAndDropQuestion key={index} pos={data.position} type={data.props.type} id={data.props.id} />)

            default:
                break;
        }
    }

    render() {
        return (
          <div>
            <p tabIndex={0}>{this.props.t("Let’s look at what you learned from this simulation. Please click on your answer to each of the following questions to save them in your notebook.")}</p>
            <div>
              {this.state.components}
            </div>
          </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
      level: state.notebook.level
    }
  }

  export default connect(mapStateToProps, {
    createMCQ,
    createSCQ,
    //createDND,
  })(withTranslation()(Reflection));
